import { createAction } from 'redux-starter-kit';

export const putTranslations = createAction('PUT_TRANSLATIONS');

export const putCurrentLocale = createAction('PUT_CURRENT_LOCALE');
